import { GeometryTypes } from './layer'

export enum PointIcons {
  Circle = 'circle',
  Diamond = 'diamond',
  Factory = 'factory',
  Flag = 'flag',
  Heart = 'heart',
  Home = 'home',
  Pin = 'pin',
  Square = 'square',
  Star = 'star',
}

export type StrokeWidth = number

export type CustomLayer = {
  id: string
  name: string
  file: {
    name: string
    url: string
  }
  geometryType: GeometryTypes
  viz: CustomLayerStyle
}

export type PointStyle = {
  paint: {
    'icon-color': string
  }
  layout: {
    'icon-image': PointIcons
  }
}

export type PolygonStyle = {
  paint: {
    'fill-color': string
  }
}

export type LineStyle = {
  paint: {
    'line-color': string
    'line-width': StrokeWidth
  }
}

export type CustomLayerStyle = PointStyle | PolygonStyle | LineStyle

export type CustomLayerCreateParams = {
  id_user: number
  name: string
  file: File
}

export type CustomLayerUpdateParams = {
  id_user: number
  name: string
  file?: File
}
